<template>
  <div>
    <el-card
      shadow="never"
      :body-style="{
        padding: '20px 15px',
      }"
    >
      <div v-if="!isEmpty">
        <Timeline>
          <TimelineItem
            v-for="(item, index) in productTestData"
            :key="index"
            v-bind="item"
          >
            <template #default="{ item }">
              <div
                class="product-test__container"
                v-for="(content, index) in item.content"
                :key="index"
              >
                <div>
                  <div class="executor">
                    <span class="label__key">执行人：</span>
                    <img
                      v-if="content.avatar"
                      :src="content.avatar"
                      class="description_avatar"
                    />
                    <span v-if="!content.avatar" class="description_avatar">
                      U
                    </span>
                    <span class="ml-5px">Danny-黄丹</span>
                  </div>
                  <div class="complete-time">
                    <span class="label__key">完成时间：</span>
                    <span>2024-01-12</span>
                  </div>
                  <div>
                    <span :class="'tag tag-' + content.type">待处理</span>
                  </div>
                  <div>
                    <span class="tag tag-view">View</span>
                  </div>
                </div>
              </div>
            </template>
          </TimelineItem>
        </Timeline>
      </div>
      <div v-else class="not-data__container">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import Timeline from '../timeline/index.vue'
import TimelineItem from '../timeline/item.vue'
export default {
  props: {
    devTrackingCode: { type: String, default: '' },
  },
  components: { Timeline, TimelineItem },
  data() {
    return {
      productTestData: [
        {
          type: 'T',
          title: '产品测试',
          time: '2024-01-10 10:10:30',
          name: 'Ping-鄢萍',
          avatar:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202211/eb0e81e1ace7616d9fe1f1008cf9c39f.jpg?Expires=2017386112&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=n0PPMOE712DKaryzWZeRn03cOro%3D',
          content: [{ type: 'A' }, { type: 'B' }],
        },
        {
          type: 'T',
          title: '产品测试',
          time: '2024-01-10 10:10:30',
          name: 'Ping-鄢萍',
          avatar:
            'https://abs-oss.oss-cn-shanghai.aliyuncs.com/202211/eb0e81e1ace7616d9fe1f1008cf9c39f.jpg?Expires=2017386112&OSSAccessKeyId=LTAI4G9GTRRdivUVG4GXBpXM&Signature=n0PPMOE712DKaryzWZeRn03cOro%3D',
          content: [{ type: 'B' }],
        },
      ],
      loading: false,
    }
  },
  computed: {
    isEmpty() {
      return !this.productTestData || !this.productTestData.length
    },
  },
}
</script>
<style lang="scss" scoped>
.product-test__container:last-child {
  padding-bottom: 40px !important;
}
.product-test__container {
  display: flex;
  flex: 1;
  margin-top: 10px;
  > div {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    border-radius: 5px;
    border: 1px dotted #bbbbbb;
    padding: 0 15px;
    .executor {
      font-size: 14px;
      color: #303133;
      .description_avatar {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        background-color: #cccccc;
        color: #fff;
        font-size: 14px;
        cursor: default;
        margin-left: auto;
      }
    }
    .complete-time {
      color: #303133;
      font-size: 14px;
    }
  }
}
.tag {
  width: 100px;
  height: 30px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
}
.tag-A {
  background-color: #efefef;
  color: #4f4f4f;
}
.tag-view {
  width: 60px !important;
  height: 30px;
  background-color: #efefef;
  color: #4f4f4f;
  cursor: pointer;
}
.tag-view:hover {
  background-color: #e7f1fe;
  color: #307af9;
}
.tag-B {
  background-color: #e7f1fe;
  color: #307af9;
}
.ml-5px {
  margin-left: 5px;
}
.label__key {
  color: #8e8e8e;
  font-size: 13px;
  font-weight: 600;
}
.not-data__container {
  height: 500px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
